// 캠페인(불편접수함) 페이지 카카오 인증 처리
// 글쓰기/좋아요 API 는 카카오 액세스 토큰을 Authorization 헤더로 받는다.
import Cookie from '@/utilities/cookie';

const TOKEN_KEY = "campaignKakaoToken";

export default {
    getToken: function()
    {
        return Cookie.getLocalStorageWithExpire(TOKEN_KEY);
    },

    setToken: function(token)
    {
        Cookie.setLocalStorageWithExpire(TOKEN_KEY, token);
    },

    clearToken: function()
    {
        Cookie.deleteLocalStorageWithExpire(TOKEN_KEY);
    },

    // 카카오 로그인 화면으로 이동. path 는 로그인 후 돌아올 경로
    login: function(path)
    {
        const REST_API_KEY = process.env.KAKAO_REST_API_KEY;
        const REDIRECT_URI = process.env.KAKAO_REDIRECT_URI;
        const STATE = process.env.LOGIN_URI + path;
        window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&response_type=code&prompt=login&state=${STATE}`;
    },

    // 토큰을 버리고 현재 페이지로 돌아오는 카카오 로그인.
    // isPost 가 true 면 로그인 후 작성 팝업이 다시 열린다.
    relogin: function(isPost)
    {
        this.clearToken();
        this.login(isPost ? `${window.location.pathname}?ispost=true` : window.location.pathname);
    },

    // 토큰 없음/만료/무효(401), 카카오 서버 장애(502) 여부
    // 파라미터 오류는 HTTP 200 + status: "fail" 로 오므로 여기에 해당하지 않는다.
    isAuthError: function(err)
    {
        const status = err && err.response ? err.response.status : null;
        return status === 401 || status === 502;
    }
}



// WEBPACK FOOTER //
// ./src/utilities/campaignAuth.js